<template>
<div class="banner">
  <slider :options="swiperOptions" @slide='slide' @tap='onTap' @init='onInit'>
    <slideritem v-for="(item,index) in swiperPages" :key="index">
      <img v-lazy="item.image" style="width: 100%;height: 100%;object-fit: cover">
    </slideritem>
  </slider>
</div>
</template>

<script>
import { slider, slideritem } from 'vue-concise-slider'
export default {
  components: {
    slider,
    slideritem
  },
  data() {
    return {
      swiperPages: [
        {
          image: require('@/assets/home/banner-1.jpg')
        },
        {
          image: require('@/assets/home/banner-2.jpg')
        }
      ],
      swiperOptions: {
        // currentPage: 0,//当前页码
        // thresholdDistance: 500,//滑动判定距离
        // thresholdTime: 100,//滑动判定时间
        autoplay: 5000,//自动滚动[ms]
        loop: true,//循环滚动
        // direction: 'horizontal',//方向设置，垂直滚动
        // loopedSlides: 1,//无限滚动前后遍历数
        // slidesToScroll: 1,//每次滑动项数
        // timingFunction: 'ease', // 滑动方式
        // speed: 500, // 滑动时间
        pagination: true,
        thresholdDistance: 100, // Sliding distance threshold
        thresholdTime: 300, // Sliding time threshold decision
        grabCursor: true, // Scratch style
        speed: 300 // Sliding speed
      },
    }
  },
  methods: {
    slide() {},
    onTap() {},
    onInit() {},
  },
}
</script>

<style>
.banner{
    height: 650px;
}
</style>
